import React from 'react';
import { CheckmarkIcon } from '../../icons';
var MuiAlert = {
    /* put your new default props here */
    iconMapping: {
        info: React.createElement("span", null, "i"),
        success: React.createElement(CheckmarkIcon, null),
        warning: React.createElement("span", null, "!"),
        error: React.createElement("span", null, "!"),
    },
};
export default MuiAlert;
//# sourceMappingURL=MuiAlert.js.map